import { useState } from 'react'
import { Button } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { useClient } from '@/hooks/useClient'
import { saveBlob } from '@/utils/downloadAttachment'
import type { ReportInput } from './state'

export function ExportCsvButton({
  input,
  groupKey,
  disabled,
}: {
  input: ReportInput
  groupKey: string | undefined
  disabled: boolean
}) {
  const client = useClient()
  const [pending, setPending] = useState(false)

  async function handleExport() {
    setPending(true)

    try {
      const file = await client.billingV2ReportExport({
        ...input,
        ...(groupKey !== undefined ? { groupKey } : {}),
      })
      saveBlob(file, `behuman-accounting-${input.report}-${input.dateTo}.csv`)
    } catch (err) {
      showNotification({
        color: 'red',
        message: err instanceof Error ? err.message : 'The CSV could not be built.',
      })
    } finally {
      setPending(false)
    }
  }

  return (
    <Button onClick={handleExport} loading={pending} disabled={disabled}>
      Export detailed CSV
    </Button>
  )
}
